import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { httpMiddleware } from '@minerva-analytics/pantheon';

import rootReducer from './reducers';

const middlewares = [thunk, httpMiddleware];

export default (preloadedState = {}, customMiddleware = []) =>
  createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(...middlewares, ...customMiddleware),
  );
